import React from "react";

export function DMSDateColumnFormatter(cellContent, row) {
  if (!cellContent) return <span>-</span>;
  try {
    const d = new Date(cellContent);
    if (isNaN(d)) return <span>{cellContent}</span>;
    const day = String(d.getDate()).padStart(2, '0');
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const mon = months[d.getMonth()];
    const yr = String(d.getFullYear()).slice(-2);
    const hr = d.getHours();
    const min = String(d.getMinutes()).padStart(2, '0');
    const ampm = hr >= 12 ? 'pm' : 'am';
    const hr12 = hr % 12 || 12;
    return (
      <div
        className="text-gray-700"
        style={{
          fontSize: '0.8rem',
          whiteSpace: 'nowrap',
          lineHeight: 1.2,
        }}
      >
        <div className="fw-semibold">{day} {mon} {yr}</div>
        <div className="text-gray-500 fw-normal" style={{ fontSize: '0.75rem' }}>
          {hr12}:{min} {ampm}
        </div>
      </div>
    );
  } catch {
    return <span>{cellContent}</span>;
  }
}
